import Work1 from "../../assets/crickshot.png";
import Work2 from "../../assets/handmouse.png";
import Work3 from "../../assets/resume-ranking.png";
import Work4 from "../../assets/bloodline.png";
import tcp from "../../assets/tcp.png";
import git from "../../assets/git.png";
import alora from "../../assets/alora.png";

const Menu = [
  {
    id: 1,
    image: alora,
    title: "Alora - WebSite Builder with AI",
    category: ["Next.js"],
    url: "https://alora-lake.vercel.app",
    repositoryUrl: "https://github.com/devanshpandey2003/alora",
  },
  {
    id: 1,
    image: Work1,
    title: "CrickShot - Sports Performance Analysis",
    category: ["AI/ML"],
    url: "https://v0-crickboost.vercel.app/",
    repositoryUrl: "https://github.com/devanshpandey2003/CrickShot",
  },
  {
    id: 2,
    image: Work2,
    title: "Hand Gesture Controlled Mouse",
    category: ["AI & ML"],
    repositoryUrl: "https://github.com/devanshpandey2003/Hand_Mouse",
  },
  {
    id: 3,
    image: Work3,
    title: "Resume Ranking System",
    category: ["AI & ML"],
    url: "https://v0-normal-resume-ranking-website-o0soob.vercel.app/",
    repositoryUrl: "https://github.com/devanshpandey2003/Resume_Ranking",
  },
  {
    id: 4,
    image: Work4,
    title: "PlusFitGym",
    category: ["Next.js"],
    url: "https://plus-fitt.vercel.app/",
    repositoryUrl: "https://github.com/devanshpandey2003/PlusFitt",
  },
  {
    id: 5,
    image: tcp,
    title: "Custom Protocol - A Lightweight Communication Protocol",
    category: ["Backend"],
    repositoryUrl: "https://github.com/devanshpandey2003/MyProtocol",
  },
  {
    id: 6,
    image: git,
    title: "MiniGit - A Version Control System",
    category: ["Backend"],
    repositoryUrl: "https://github.com/devanshpandey2003/MiniGit",
  },
];

export default Menu;
